module.exports = __webpack_public_path__ + "img/event2-compressed.b339b113.jpg";